import { Box, BoxProps } from "@mui/material";
import { toSxArray } from "src/utils/mui/sx/sx";

export const WfDialogFooter = ({ children, ...props }: BoxProps) => {
    return (
        <Box
            {...props}
            sx={[
                {
                    position: { xs: "absolute", sm: "static" },
                    bottom: { xs: "24px", sm: "unset" },
                    width: { xs: "calc(100% - 48px)", sm: "auto" },
                },
                ...toSxArray(props.sx),
            ]}
        >
            {children}
        </Box>
    );
};
